import { useTranslation } from 'react-i18next';

const Partners = () => {
  const { t } = useTranslation('common');

  // Mock partner logos with realistic company names
  const partners = [
    { name: 'CryptoEx', category: 'exchange' },
    { name: 'PayFlow', category: 'saas' },
    { name: 'GameChain', category: 'gaming' },
    { name: 'TradePro', category: 'otc' },
    { name: 'CloudPay', category: 'saas' },
    { name: 'CoinBase', category: 'exchange' },
    { name: 'MetaGame', category: 'gaming' },
    { name: 'OTCGlobal', category: 'otc' },
    { name: 'SwiftPay', category: 'saas' },
    { name: 'ChainTrade', category: 'exchange' },
    { name: 'PlayEarn', category: 'gaming' },
    { name: 'LiquidPro', category: 'otc' }
  ];

  const categories = [
    { key: 'exchange', label: t('partners.categories.0'), icon: 'ri-exchange-line', color: 'from-blue-500 to-cyan-500' },
    { key: 'saas', label: t('partners.categories.1'), icon: 'ri-cloud-line', color: 'from-purple-500 to-pink-500' },
    { key: 'gaming', label: t('partners.categories.2'), icon: 'ri-gamepad-line', color: 'from-green-500 to-emerald-500' },
    { key: 'otc', label: t('partners.categories.3'), icon: 'ri-bank-line', color: 'from-orange-500 to-red-500' }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(6,182,212,0.05),transparent_70%)]"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-slate-800 mb-6">
            {t('partners.title')}
          </h2>
          <p className="text-xl text-slate-600">
            {t('partners.subtitle')}
          </p>
        </div>

        {/* Categories */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {categories.map((category) => (
            <div key={category.key} className="text-center p-6 bg-white rounded-2xl border border-slate-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105">
              <div className={`w-16 h-16 mx-auto mb-4 bg-gradient-to-r ${category.color} rounded-2xl flex items-center justify-center`}>
                <i className={`${category.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-semibold text-slate-800">
                {category.label}
              </h3>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6">
            <div className="text-4xl font-bold text-cyan-600 mb-2">100+</div>
            <p className="text-slate-600">{t('partners.stats.clients')}</p>
          </div>
          <div className="text-center p-6">
            <div className="text-4xl font-bold text-blue-600 mb-2">99.9%</div>
            <p className="text-slate-600">{t('partners.stats.uptime')}</p>
          </div>
          <div className="text-center p-6">
            <div className="text-4xl font-bold text-purple-600 mb-2">24/7</div>
            <p className="text-slate-600">{t('partners.stats.support')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;